import React from 'react'
import { observer } from 'mobx-react'
import { TableHost } from 'components/Table'
import { JobsTabViewModel } from './JobsTabViewModel'
import VirtualTable from '../../../payouts/components/VirtualTable'
import styles from './JobsTab.sass'
import WorkspaceFilterViewHeading from '../../../components/WorkspaceFilterViewHeading'
import SearchableJob from '../../../jobs/SearchableJob'
import { useHistory } from 'react-router'
import link from '../../../infra/link'
import JobsTableHeaderRow from '../../components/UserDetailsJobsTableHeaderRow'
import { JobsTableCell } from '../../../jobs/views/JobManagement/JobsTable/JobsTableRow'
import JobsViewerHeader from '../../../jobs/views/JobManagement/JobsViewerHeader'
import { JobCount } from '../../../jobs/views/JobManagement/JobsViewer'
import UserManagementEmptyState from 'user-management/components/UserManagementEmptyState'

interface Props {
  vm: JobsTabViewModel
}

export default observer(({ vm }: Props) => {
  const history = useHistory()

  return (
    <>
      <div className={styles.userJobsTableWorkspaceSwitcher}>
        <WorkspaceFilterViewHeading
          allOptionText="All Workspaces"
          primaryText=""
          filter={vm.workspacesFilter}
          viewHeadingSize="small"
        />

        <JobCount vm={vm.jobManagementViewModel} />
      </div>

      <div className={styles.userJobsTable}>
        <TableHost>
          <JobsViewerHeader vm={vm.jobManagementViewModel} />
          {!vm.shouldShowEmptyState ? (
            <VirtualTable
              overscan={50}
              scroller={vm.jobManagementViewModel.searcher.scroller}
              totalCount={vm.jobManagementViewModel.searcher.jobs.length}
              headerContent={() => (
                <JobsTableHeaderRow
                  vm={vm.jobManagementViewModel.columnManager}
                  getSortOrder={vm.jobManagementViewModel.getSortOrder.bind(
                    vm.jobManagementViewModel,
                  )}
                  setSortOrder={vm.jobManagementViewModel.setSortOrder.bind(
                    vm.jobManagementViewModel,
                  )}
                />
              )}
              itemContent={(index) => {
                const job = vm.jobManagementViewModel.searcher.jobs[index]
                return (
                  <JobsTableCell vm={vm.jobManagementViewModel} job={job} />
                )
              }}
              onClickItemRow={(job: SearchableJob) =>
                history.push(link.job(job.id))
              }
            />
          ) : (
            <UserManagementEmptyState
              isSearchFilterApplied={vm.isSearchFilterApplied}
              onClearSearchFilterClick={() => vm.clearFilters()}
            />
          )}
        </TableHost>
      </div>
    </>
  )
})
